import moment from 'moment-jalaali'

import { PanelLocale } from './locale'

/** Initialise both branches explicitly, including after a previous Persian session. */
export function configureDateLocale(locale: PanelLocale): void {
  if (locale === 'fa') {
    moment.loadPersian({ dialect: 'persian-modern', usePersianDigits: false })
  }
  moment.locale(locale)
}
